import { useNavigate } from "react-router-dom";
import { getTextWorkCity, formatDate, convertTitleText } from "./common/BaseUtil"
import { getUniqLogoUrl, getEmptyLogoUrl } from "../component/common/BaseUtil"
import { CheckAndShowLogo } from "../component/common/Logo"
import '../App.css';

export function JobCard(props) {
    const navigate = useNavigate();
    const deadline = props.object.postEndDate?.slice(0, 10);
    
    function onClick() {
        let objectId = props.object.id.toString()
        let returnTo = props.returnTo
        let url = "/job?id=" + objectId + "&returnTo=" + returnTo;
        navigate(url);
    }

    const fixedImageStyle = {
        width: '180px',      // 원하시는 가로 길이
        height: '70px',     // 원하시는 세로 길이
        objectFit: 'contain', // 중요: 비율을 유지하며 영역 안에 맞춤 (글자가 잘리지 않음)
        backgroundColor: '#f8f9fa', // 로고가 작을 경우 대비용 배경색
        borderRadius: '8px',
        marginBottom: "20px",
    };

    return (
        <div class="card" key={props.index} style={{ minHeight: '270px', marginTop: '15px', marginBottom: '15px' }}>
            <div class="card-body">
                <CheckAndShowLogo
                    imageUrl={props.object.fileName ? getUniqLogoUrl(props.object.uniqFileName, props.object.fileFormat) : getEmptyLogoUrl("empty_logo", "png")}
                    alt="유효한 이미지"
                    imageAlign="center"
                    style={fixedImageStyle}
                />
                <h6 class="text-muted card-subtitle mb-2" style={{ fontFamily: 'Nanum Gothic' }}>회사:{props.object.cpName}</h6>
                <h5 class="card-title" style={{ fontFamily: 'Nanum Gothic', fontWeight: 'bold', whiteSpace: "break-spaces", display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', minHeight: '48px', height: 'auto' }}>{props.object.objTitle}</h5>
                <p className="card-text" style={{ marginBottom: '5px' }}>
                    📍 {getTextWorkCity(props.cityList, props.object.workCity)}
                </p>
                <p className="card-text">
                    {deadline
                        ? `지원마감: ${deadline}`
                        : "🟢 상시채용"}
                </p>
                <button class="btn btn-outline-info" onClick={onClick} type="button">자세히</button>
            </div>
        </div>
    );
}

